module.exports = __webpack_public_path__ + "img/banner-pc.3f2689ca.png";